import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadMessages(context) {
  const messages = {};
  context.keys().forEach(key => {
    const namespace = key.replace(/^\.\//, '').replace(/\.js$/, '');
    messages[namespace] = context(key).default;
  });
  return messages;
}

const idContext = require.context('./locales/id', false, /\.js$/);
const enContext = require.context('./locales/en', false, /\.js$/);
const jaContext = require.context('./locales/ja', false, /\.js$/);

const messages = {
  id: loadMessages(idContext),
  en: loadMessages(enContext),
  ja: loadMessages(jaContext),
};

const supportedLocales = ['id', 'en', 'ja'];
const savedLocale = localStorage.getItem('locale');
const locale = supportedLocales.includes(savedLocale) ? savedLocale : 'en';

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages,
  silentFallbackWarn: true,
});

export default i18n;
